function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M40 20c0 11-9 20-20 20S0 31 0 20 9 0 20 0s20 9 20 20",
    className: "activity_svg__st0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ff9800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8 12.2c-.2-.8-.8-1.4-1.6-1.6-1-.3-2.6-.6-4.5-.6l6.7 6.7c0-1.9-.3-3.4-.6-4.5M9.9 28.9c.2.8.8 1.4 1.6 1.6 1 .3 2.6.6 4.5.6l-6.7-6.7c0 1.9.3 3.5.6 4.5m-.4-7.1 9.2 9.2c5.6-.8 10.6-5.1 11.6-11.6L21 10.2c-5.6.8-10.6 5-11.5 11.6M23 16.5c.1-.1.3-.1.5 0l.5.5c.1.1.1.3 0 .5l-1.2 1.2 1.2 1.2c.1.1.1.3 0 .5l-.5.5c-.1.1-.3.1-.5 0l-1.2-1.2-1 1 1.2 1.2c.1.1.1.3 0 .5l-.5.5c-.1.1-.3.1-.5 0l-1.2-1.2-1 1 1.2 1.2c.1.1.1.3 0 .5l-.5.5c-.1.1-.3.1-.5 0l-1.2-1.2-1.2 1.2c-.1.1-.3.1-.5 0l-.5-.5c-.1-.1-.1-.3 0-.5l1.2-1.2-1.2-1.2c-.1-.1-.1-.3 0-.5l.5-.5c.1-.1.3-.1.5 0l1.2 1.2 1-1-1.2-1.2c-.1-.1-.1-.3 0-.5l.5-.5c.1-.1.3-.1.5 0l1.2 1.2 1-1-1.2-1.2c-.1-.1-.1-.3 0-.5l.5-.5c.1-.1.3-.1.5 0l1.2 1.2z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgActivity;